import script from "./FeaturedHackathons.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedHackathons.vue?vue&type=script&setup=true&lang=js"

export default script